import { useEffect } from 'react';
import { gql, useMutation } from '@apollo/client';

import {
  SET_ON_CONTINUE,
  SET_LOADING,
  SET_SUCCESS,
} from '../../reducers/actionReducer';
import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';

const ENABLE_USER = gql`
  mutation EnableUser($id: ID!) {
    enableUser(id: $id) {
      message
    }
  }
`;

type EnableUserProps = {
  id: string;
  dispatchAction: (action: any) => void;
  usersQuery: any;
};

export default function EnableUser({
  id,
  dispatchAction,
  usersQuery,
}: EnableUserProps) {
  const [enableUser, { loading, error, called, data }] = useMutation(
    ENABLE_USER,
    {
      refetchQueries: [usersQuery, 'users'],
    }
  );

  useEffect(() => {
    if (id && enableUser) {
      dispatchAction({
        type: SET_ON_CONTINUE,
        payload: {
          onContinue: () => enableUser({ variables: { id } }),
        },
      });
    }
  }, [dispatchAction, id, enableUser]);

  useEffect(() => {
    if (loading !== undefined) {
      dispatchAction({
        type: SET_LOADING,
        payload: { loading },
      });
    }
  }, [dispatchAction, loading]);

  useEffect(() => {
    if (called && data && !error) {
      dispatchAction({
        type: SET_SUCCESS,
        payload: {
          message: 'User enabled successfully.',
        },
      });
    }
  }, [called, data, dispatchAction, error]);

  return (
    <div className="flex flex-col justify-center items center text-center space-y-4">
      {loading && <LoadingSpinner />}
      {error && <ErrorText message={error.message} />}
      {!loading && !error && (
        <>
          <p>
            This will enable the user and allow them to log in and use the app.
          </p>
          <p>Would you like to continue?</p>
        </>
      )}
    </div>
  );
}
